/**
 * Checks if a group of marketplaces contains at least one marketplace without a parent
 * @param marketplaces
 */
export const containsOrphanMarketplace: (
  marketplaces: { parentMarketplaceId?: string }[],
) => boolean = (marketplaces: { parentMarketplaceId?: string }[]) =>
  marketplaces.some((marketplace) => !marketplace.parentMarketplaceId);
